// Copyright (c) 2025 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildPayload} from '../services/amount-of-use-request-build-payload';
import {getAmountOfUseRequests} from '../../shared/repositories';

export const readAmountOfUseRequests = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(selectedAccounts);

        try {

            const data = await getAmountOfUseRequests(payload);

            dispatch({
                data,
                type: actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS
            });

            dispatch({
                length: data.length,
                type: actions.UPDATE_TCSM_AMOUNT_OF_USE_LENGTH
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-amount-of-use-requests.js